import React, { Component } from 'react';
import { connect } from 'react-redux';

import MagazineItem from './magazine/magazine-item';

class MagazineView extends Component {
	getRow( posts ) {
		return (

				<div className="row-four-column col-xs-12 related-posts magazine-view" key={ posts[ 0 ].id }>
					{ posts.map( ( post, i ) => {
						return (
							<MagazineItem post={ post } ind={ i } classes="excerpt-small post" key={ post.id } />
						);
					} ) }
				</div>

		);
	}

	getRemainingRows( posts, amountPerRow ) {
		let rowsToRender = [];
		for ( let i = 0; i < posts.length; i += amountPerRow ) {
			rowsToRender.push( this.getRow( posts.slice( i, i + amountPerRow ) ) );
		}
		return rowsToRender;
	}

	render() {
		return (<div>
				{ this.getRemainingRows( this.props.posts, 4 ) }
			</div>
		);
	}
}

function mapStateToProps( { posts } ) {
	return { posts };
}

export default connect( mapStateToProps, null )( MagazineView );